<template>
  <!-- 安全课程表单公共组件:新增/编辑/详情(view)共用,自包含组织/老师/学生/资源联动逻辑 -->
  <el-form :model="value" :rules="rules" ref="courseFormRef" label-width="130px" class="demo-ruleForm"
    :disabled="type == 'view'">
    <el-form-item label="所属组织结构" prop="structure_1">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
        @handleOrganQuery="handleOrganQueryNew({ limit: false, dep: 'structure_1', major: 'structure_2', formKey: 'value' })">
      </OrganDialog>
      <el-input v-model="selectName" placeholder="请选择；不选默认全校" style="width:562px;" @focus="dialogOpen"
        @clear="handeleClear" clearable></el-input>
    </el-form-item>
    <el-form-item label="课程标题" prop="title">
      <el-input v-model="value.title" clearable placeholder="请输入" style="width:216px;"></el-input>
    </el-form-item>
    <el-form-item label="安全类型" prop="safe_level">
      <el-select v-model="value.safe_level" clearable placeholder="请选择" style="width:216px;">
        <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="证书有效时长" prop="expire_month" style="width:562px;">
      <el-radio-group v-model="expireType" @change="handleExpireChange">
        <el-radio label="无限期">无限期</el-radio>
        <el-radio label="按月">按月</el-radio>
      </el-radio-group>
      <el-input-number v-if="expireType == '按月'" v-model="value.expire_month" :min="1" :step="1" :precision="0"
        placeholder="请输入月数" style="width:160px;margin-left:12px;"></el-input-number>
      <span v-if="expireType == '按月'" style="margin-left:6px;"></span>
    </el-form-item>
    <el-form-item label="课程起止日期" style="width:562px;">
      <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:420px;" clearable @change="onDateRangeChange">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="考试前置" prop="pre_exam">
      <el-select v-model="value.pre_exam" clearable placeholder="请选择" style="width:216px;">
        <el-option v-for="item in $store.state.preExamOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="学习对象" prop="user_type">
      <el-select v-model="value.user_type" clearable placeholder="请选择" style="width:216px;"
        @change="handleUserTypeChange">
        <el-option v-for="item in $store.state.userTypeOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="关联实训室" prop="training_room_id">
      <el-select v-model="value.training_room_id" clearable filterable placeholder="请选择" style="width:216px;">
        <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
          :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="课程资源" prop="resources_ids" style="width:690px;">
      <el-select v-model="value.resources_ids" multiple clearable filterable remote
        :remote-method="getResourcesList" reserve-keyword :loading="resourcesLoading" placeholder="输入关键字搜索资源"
        style="width:420px;">
        <el-option v-for="item in resourcesOptions" :key="item.id" :label="item.title" :value="item.id">
          <p>{{ item.title }}</p>
          <p v-if="item.structure_1" class="el-option-tips">{{ item.structure_1 }}{{ item.structure_2 ? '-' +
            item.structure_2 : '' }}</p>
          <p class="el-option-tips">{{ item.safe_level }}</p>
          <p class="el-option-tips">{{ item.source }}</p>
        </el-option>
      </el-select>
      <span style="margin-left: 12px;" class="el-option-tips">已选
        {{ value.resources_ids.length }} 个资源</span>
    </el-form-item> -->
    <el-form-item style="width:690px;" v-if="value.user_type == '老师' || value.user_type == '全部（老师+学生）'">
      <template slot="label">选择老师 <span style="color:#f56c6c;">*</span></template>
      <person-picker ref="teacherPicker" type="teacher" :value="value.teacher_ids" :names="personNames.teacher_ids"
        :org1="value.structure_1" :org2="value.structure_2" :course-id="value.id" :disabled="type == 'view'"
        @change="handlePersonChange('teacher_ids', $event)"></person-picker>
    </el-form-item>
    <el-form-item style="width:690px;" v-if="value.user_type == '学生' || value.user_type == '全部（老师+学生）'">
      <template slot="label">选择学生 <span style="color:#f56c6c;">*</span></template>
      <person-picker ref="studentPicker" type="student" :value="value.student_ids" :names="personNames.student_ids"
        :org1="value.structure_1" :org2="value.structure_2" :course-id="value.id" :disabled="type == 'view'"
        @change="handlePersonChange('student_ids', $event)"></person-picker>
    </el-form-item>
    <el-form-item label="课程描述" prop="desc">
      <el-input type="textarea" v-model="value.desc" placeholder="请输入" style="width:562px;" rows='4'></el-input>
    </el-form-item>
    <!-- 考试配置(详情只读,数据直接取自列表行) -->
    <div v-if="type == 'view' && (examConfigRow.question_id || examConfigRow.question_name)"
      style="border-top:1px dashed #dcdfe6;margin-top:8px;padding-top:14px;width:100%;">
      <div style="font-weight:bold;margin-bottom:6px;">考试配置</div>
      <el-form-item label="绑定试卷">
        <el-input :value="examConfigRow.question_name" disabled style="width:562px;"></el-input>
      </el-form-item>
      <el-form-item label="考试有效期">
        <el-input :value="`${examConfigRow.exam_start_date} 至 ${examConfigRow.exam_end_date}`" disabled
          style="width:562px;"></el-input>
      </el-form-item>
      <el-form-item label="次数用尽后">
        <el-input :value="examConfigRow.end_doing" disabled style="width:216px;"></el-input>
      </el-form-item>
      <el-form-item label="可考次数">
        <el-input :value="examConfigRow.exam_count" disabled style="width:216px;"></el-input>
      </el-form-item>
      <el-form-item label="考试时间">
        <el-input :value="examConfigRow.exam_time" disabled style="width:216px;"></el-input>
      </el-form-item>
    </div>
    <el-form-item style="margin-top:8px;width:100%;text-align:right;" v-if="type != 'view'">
      <el-button type="primary" v-if="type == 'add'" @click="submitForm">确认</el-button>
      <el-button type="primary" v-if="type == 'edit'" @click="submitForm">编辑</el-button>
      <el-button @click="resetValue" style="margin-right:24px;">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mixinOrgan } from '@/assets/js/mixin/organization';
import PersonPicker from './personPicker.vue';

export default {
  name: 'CourseForm',
  mixins: [mixinOrgan],
  components: {
    PersonPicker,
  },
  props: {
    // 课程表单对象(父页面 ruleForm),组件直接修改其字段
    value: {
      type: Object,
      required: true,
    },
    // add / edit / view
    type: {
      type: String,
      default: 'add',
    },
    // 详情模式附加:考试配置(列表行数据)
    examConfigRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 初始模板:组件挂载时 value 即父页面表单模板,快照用于重置
      tep: {},
      levell: [1, 2],
      expireType: '无限期', // 证书有效时长:无限期 / 按月
      dateRange: [], // 课程起止日期(提交拆 start_date/end_date)
      resourcesOptions: [],
      resourcesLoading: false,
      // 已选人员名称(与 *_ids 顺序对应,仅用于回显展示,不提交)
      personNames: {
        teacher_ids: [],
        student_ids: [],
      },
      rules: {
        title: [{ required: true, message: `请输入`, trigger: 'blur' }],
        desc: [{ required: true, message: `请输入`, trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请选择' }],
        safe_level: [{ required: true, message: '请选择' }],
        // training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
        pre_exam: [{ required: true, message: '请选择', trigger: 'change' }],
        user_type: [{ required: true, message: '请选择', trigger: 'change' }],
        expire_month: [{ required: true, message: '请选择' }],
      },
      // 组织 watch 抑制与合并调度
      _suppressOrganWatch: false,
      _organLoadScheduled: false,
      _unsuppressTimer: null,
    };
  },
  watch: {
    // 组织结构(院系 structure_1 / 专业 structure_2)任一变化:重新加载该组织下的老师/学生
    'value.structure_1': function (val, oldVal) {
      this.onStructureChange(val, oldVal)
    },
    'value.structure_2': function (val, oldVal) {
      this.onStructureChange(val, oldVal)
    },
  },
  mounted() {
    this.tep = this.$until.easyDeepCopy(this.value || {});
  },
  created() {
    // 安全类型选项来自 store(action 内已做非空缓存,幂等)
    this.$store.dispatch('getDangerCategorys');
  },
  methods: {
    // ========= 父页面入口 =========
    // 新增:重置为模板初值
    openAdd() {
      const keys = Object.keys(this.tep)
      for (let i = 0; i < keys.length; i++) {
        this.value[keys[i]] = this.$until.easyDeepCopy(this.tep[keys[i]])
      }
      this.expireType = '无限期'
      this.dateRange = []
      if (this.selectName) this.selectName = ''
      this.selectNode = ''
      this.resourcesOptions = []
      this.personNames = { teacher_ids: [], student_ids: [] }
      this.closePersonPickers()
      this.$nextTick(() => {
        if (this.$refs.courseFormRef) this.$refs.courseFormRef.clearValidate()
      })
    },
    // 编辑回填:直接从列表数据取(列表已含 *_desc 名称字段)
    openEdit(row) {
      const src = row || {}
      // 重置为模板初值
      const keys = Object.keys(this.tep)
      for (let i = 0; i < keys.length; i++) {
        this.value[keys[i]] = this.$until.easyDeepCopy(this.tep[keys[i]])
      }
      // 键对齐回填
      const formKeys = Object.keys(this.value)
      for (let i = 0; i < formKeys.length; i++) {
        const k = formKeys[i]
        if (src.hasOwnProperty(k)) this.value[k] = src[k]
      }
      if (!this.value.structure_1 && src.depart) this.value.structure_1 = src.depart
      if (!this.value.structure_2 && src.major) this.value.structure_2 = src.major
      this.value.id = src.id
      // 逗号串 ids → 数组
      const idKeys = ['resources_ids', 'teacher_ids', 'student_ids']
      for (let j = 0; j < idKeys.length; j++) {
        const k = idKeys[j]
        const v = this.value[k]
        if (typeof v == 'string' && v) {
          this.value[k] = v.split(',').filter(Boolean)
        } else if (!Array.isArray(v)) {
          this.value[k] = []
        }
      }
      // 资源选项直接用列表 desc(资源标题与名称一致)
      this.resourcesOptions = this.buildIdDescOptions(src.resources_ids, src.resources_ids_desc, 'title')
      // 列表只回了 *_desc(id 串),没有 ids 字段,用它回填已选人员,否则编辑会把已选人丢掉
      this.fillPersonIds(src)
      // 已选人员姓名:desc 里是姓名就展示,只是 id 串则留空(选择器只显示人数)
      this.personNames = {
        teacher_ids: this.splitNames(src.teacher_ids_desc || src.teacher_id_desc),
        student_ids: this.splitNames(src.student_ids_desc),
      }
      this.expireType = this.value.expire_month ? '按月' : '无限期'
      if (this.value.expireType) delete this.value.expireType
      // 课程起止日期回显
      this.dateRange = (this.value.start_date && this.value.end_date) ? [this.value.start_date, this.value.end_date] : []
      const dep = this.value.structure_1 || src.depart
      const major = this.value.structure_2 || src.major
      this.selectName = dep ? `${dep}${major ? `-${major}` : ''}` : ''
      // 抑制 watch 重复加载,由这里按当前行组织(user_type)显式加载一次
      this.suppressOrganWatchAndLoad()
      this.$nextTick(() => {
        if (this.$refs.courseFormRef) this.$refs.courseFormRef.clearValidate()
      })
    },
    // 详情(view)回填:与编辑同构(列表 desc 兜底、人员按组织加载),仅只读
    openView(row) {
      this.openEdit(row)
    },
    suppressOrganWatchAndLoad() {
      this._suppressOrganWatch = true
      clearTimeout(this._unsuppressTimer)
      this._unsuppressTimer = setTimeout(() => { this._suppressOrganWatch = false }, 400)
    },
    // 子弹窗(选择器)随上层表单弹窗开合显式收起
    closePersonPickers() {
      this.$nextTick(() => {
        if (this.$refs.teacherPicker) this.$refs.teacherPicker.close()
        if (this.$refs.studentPicker) this.$refs.studentPicker.close()
      })
    },
    // ========= 内部联动 =========
    handleUserTypeChange() {
      // 切换学习对象时清空已选老师/学生
      this.value.teacher_ids = []
      this.value.student_ids = []
      this.personNames = { teacher_ids: [], student_ids: [] }
      this.closePersonPickers()
    },
    // 选择器确认后回写 ids 与名称
    handlePersonChange(key, payload) {
      this.value[key] = payload.ids
      this.$set(this.personNames, key, payload.names)
      this.$nextTick(() => {
        if (this.$refs.courseFormRef) this.$refs.courseFormRef.clearValidate(key)
      })
    },
    // 课程起止日期选择:同步写入 start_date/end_date(清空则置空)
    onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.value.start_date = val[0]
        this.value.end_date = val[1]
      } else {
        this.value.start_date = ''
        this.value.end_date = ''
      }
    },
    handleExpireChange(val) {
      if (val == '无限期') {
        this.value.expire_month = 0
      }
    },
    // 组织结构(院系/专业)任一变化时的处理:
    // 同一 tick 内 structure_1、structure_2 同时变化只合并调度一次;编辑回填期间由 openEdit 显式加载,此处抑制
    onStructureChange(val, oldVal) {
      if (this._suppressOrganWatch) return
      if (this._organLoadScheduled) return
      this._organLoadScheduled = true
      setTimeout(() => {
        this._organLoadScheduled = false
        if (this._suppressOrganWatch) return
        // 组织真的发生变化:清空已选人员,避免选到别的组织的人
        if (oldVal && val != oldVal) {
          this.value.teacher_ids = []
          this.value.student_ids = []
          this.personNames = { teacher_ids: [], student_ids: [] }
        }
      }, 0)
    },
    async getResourcesList(query) {
      this.resourcesLoading = true;
      let res = await this.$api.instance.interfaceServer('api/new_course_resources/list', 'get', { title: query, page: 1, size: 999, post: 1 });
      this.resourcesLoading = false;
      if (res.code == 0 && res.data) {
        this.resourcesOptions = res.data.data;
      }
    },
    // id 串与 desc 串按逗号对齐,构造 { id, labelKey } 选项
    buildIdDescOptions(ids, desc, labelKey) {
      const opts = []
      const idArr = (ids || '').split(',').map(s => s.trim()).filter(Boolean)
      const descArr = (desc || '').split(',').map(s => s.trim()).filter(Boolean)
      for (let i = 0; i < idArr.length; i++) {
        const opt = { id: idArr[i] }
        opt[labelKey] = descArr[i] || idArr[i]
        opts.push(opt)
      }
      return opts
    },
    // desc 串 → 姓名数组;desc 只给 id(纯数字)时按「没有姓名」处理,返回空数组,选择器只显示人数
    splitNames(desc) {
      return String(desc || '')
        .split(',')
        .map(s => s.trim())
        .filter(s => s && !/^\d+$/.test(s))
    },
    // 列表接口只返回 *_desc(逗号分隔的 id 串),没有 ids 字段,用它回填已选人员
    fillPersonIds(src) {
      const studentDesc = src.student_ids_desc || src.student_id_desc
      if (!this.value.student_ids.length && studentDesc) {
        this.value.student_ids = String(studentDesc).split(',').filter(Boolean)
      }
      const teacherDesc = src.teacher_ids_desc || src.teacher_id_desc
      if (!this.value.teacher_ids.length && teacherDesc) {
        this.value.teacher_ids = String(teacherDesc).split(',').filter(Boolean)
      }
    },
    // ========= 提交 / 重置 =========
    // 组装提交参数(与页面原 prepareSubmitParams 一致)
    buildParams() {
      if (this.expireType == '按月' && !this.value.expire_month) {
        this.$message({
          type: 'warning',
          center: true,
          message: '请选择按月并输入证书有效时长（月）',
        });
        return null;
      }
      let params = this.$until.deleteNullPrototype(this.$until.easyDeepCopy(this.value));
      // ids 数组 → 逗号串,并生成对应 count(未选时 count 默认 0,ids 空串不提交)
      ['resources_ids', 'teacher_ids', 'student_ids'].forEach(key => {
        const countKey = key.replace('_ids', '_count');
        if (params[key] && params[key].length) {
          params[countKey] = params[key].length;
          params[key] = params[key].join(',');
        } else {
          params[countKey] = 0;
          delete params[key];
        }
      });
      // 无限期:expire_month 传 0
      if (this.expireType != '按月') {
        params.expire_month = 0;
      }
      return params;
    },
    // 人员字段由选择器自定义控件承载,不走 el-form 规则(否则选择器内部的搜索框、复选框会触发外层校验)
    checkPersonPicked() {
      const ut = this.value.user_type;
      if ((ut == '学生' || ut == '全部（老师+学生）') && !this.value.student_ids.length) {
        this.$message({ type: 'warning', center: true, message: '请选择学生' });
        return false;
      }
      if ((ut == '老师' || ut == '全部（老师+学生）') && !this.value.teacher_ids.length) {
        this.$message({ type: 'warning', center: true, message: '请选择老师' });
        return false;
      }
      return true;
    },
    submitForm() {
      if (!this.checkPersonPicked()) return;
      this.$refs.courseFormRef.validate((valid) => {
        if (!valid) return;
        const params = this.buildParams();
        if (!params) return;
        this.$emit('submit', params);
      });
    },
    resetValue() {
      if (this.$refs.courseFormRef) this.$refs.courseFormRef.resetFields();
      if (this.selectName) {
        this.selectName = ''
        this.selectNode = ''
      }
      // 人员选择器不在 el-form 可重置字段内,显式清空
      this.value.teacher_ids = []
      this.value.student_ids = []
      this.personNames = { teacher_ids: [], student_ids: [] }
      this.closePersonPickers()
      this.$nextTick(() => {
        if (this.$refs.courseFormRef) this.$refs.courseFormRef.clearValidate()
      })
    },
  },
};
</script>
